import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@regulaforensics/vp-frontend-face-components";
import App from "./App";
import theme from "./theme";
import { store } from "./redux";
import { msalConfig } from "./auth";
import { MaintenanceWrapper } from "@claimscon/apputils";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

if (process.env.NODE_ENV === "development" && window.Cypress) {
  window.store = store;
}

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <MsalProvider instance={msalInstance}>
          <MaintenanceWrapper
            app="paneem"
            admin={false}
            env={
              window.location.href.includes("test") || window.location.href.includes("localhost")
                ? "development"
                : "production"
            }
          >
            <App />
          </MaintenanceWrapper>
        </MsalProvider>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);
